"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _operators = require("rxjs/operators");

var _js = require("@agile-actors/actions/dist/js");

var request = function request(requestCreator) {
  for (var _len = arguments.length, responseActions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    responseActions[_key - 1] = arguments[_key];
  }

  return (0, _operators.map)(function (action) {
    return (0, _js.request)({
      response: function response() {
        return Promise.resolve(requestCreator(action));
      },
      responseActions: responseActions
    });
  });
};

var _default = request;
exports["default"] = _default;